/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  // Inclui agentes não-humanos (bot users dos agentes de IA do Studio).
  // Usado onde o id configurado é um assignee possível (ex.: auto-resolve).
  listAll() {
    return axios.get(this.url, { params: { include_non_human: true } });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  setPassword(id, password, passwordConfirmation) {
    return axios.patch(`${this.url}/${id}/set_password`, {
      password,
      password_confirmation: passwordConfirmation,
    });
  }
}

export default new Agents();
